/*@ngInject*/
const AttachmentEmailsRepository = function (baseRepository) {

    angular.extend(this, baseRepository);

    this.retrieveAttachmentEmails = function (attachmentId) {
        let url = '/rest/UnderwritingAttachment/' + attachmentId + '/Email';

        return this.get(url);
    };
};

angular.module('umCore')
    .service('attachmentEmailsRepository', AttachmentEmailsRepository);
